import { Button, Modal } from "antd";
import React, { useState } from "react";
import isEqual from "react-fast-compare";
import {
  setScreenDeepDiveData,
  setScreenUpdatedData,
} from "../../../redux/actions/commandCenter/screens/screen";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePostFromTool,
  hidePostFromTool,
} from "../../../redux/actions/commandCenter/commandCenterApi";
import { getDeepDive } from "../../../redux/actions/WidgetMaker/WidgetAPI";
const HidePostModal = ({ isOpen, setHidePost, hidePost, deepDive }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const screen = useSelector((state) => state?.Screens?.screen);
  const infoBarObject = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );

  const handleCancelHidePost = () => {
    setHidePost({
      modalShow: false,
      data: null,
    });
  };

  const handleHidePost = () => {
    let postData = hidePost?.data;
    // console.log("handleHidePost", postData);
    let payloadObject = {
      tagid: postData?.tagid,
      authParams: authParams,
    };
    dispatch(hidePostFromTool(payloadObject));
    setHidePost({
      modalShow: false,
      data: null,
    });
    mentionChartApiCall();
  };

  const mentionChartApiCall = () => {
    let selectedPost = hidePost?.data;

    let screenData = { ...screen };
    let updatedScreenWidgets = screenData?.widgets?.length
      ? screenData?.widgets
      : [];

    let selectedWidget = updatedScreenWidgets?.find(
      (d) => d?.widget_id === "000-100-974"
    );
    // console.log("selectedWidget", selectedWidget);

    let updatedWidgetData = selectedWidget?.graphData
      ? selectedWidget?.graphData?.data?.[`custom-card`]?.[0]?.data?.filter(
          (d) => d?.tagid !== selectedPost?.tagid
        )
      : selectedWidget?.persist_graphdata?.data?.[
          `custom-card`
        ]?.[0]?.data?.filter((d) => d?.tagid !== selectedPost?.tagid);
    // console.log("updatedWidgetData", updatedWidgetData);

    updatedScreenWidgets = updatedScreenWidgets?.map((d) => {
      if (d?.widget_id === "000-100-974") {
        d.deletedTagId = selectedPost?.tagid;
        d.graphData.data[`custom-card`][0].data = updatedWidgetData;
        d.persist_graphdata.data[`custom-card`][0].data = updatedWidgetData;
      }
      if (d?.widget_id === "000-100-976") {
        d.graphData = null;
      }
      return d;
    });

    // console.log("updatedScreenWidgets", updatedScreenWidgets);
    screenData = {
      ...screenData,
      widgets: updatedScreenWidgets?.length ? updatedScreenWidgets : [],
    };
    dispatch(setScreenUpdatedData(screenData));
  };

  return (
    <>
      <Modal
        title=""
        open={isOpen}
        style={{
          top: 100,
        }}
        // mask={false}
        footer={null}
        closable={false}
        className="stream__closeModal"
      >
        <div class="stream__closeModal--tickIcon">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
        <div
          style={{ fontSize: "1.8rem" }}
          className="stream__closeModal--title text-center"
        >
          Do you want to hide this post from warroom screen ?
        </div>
        <div className="d-flex align-items-center stream__closeModal--btns">
          <Button
            className="command__center--primaryBtn"
            onClick={handleCancelHidePost}
          >
            No
          </Button>
          <Button
            className="command__center--secondaryBtn"
            onClick={handleHidePost}
          >
            Yes
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default React.memo(HidePostModal, isEqual);
